<div class="modal-notificacao">
  <div class="modal-notificacao__container">
    <div class="modal-notificacao__icon">
      <ng-icon [name]="_notificacao.categoria.icon"></ng-icon>
    </div>

    <div class="modal-notificacao__content">
      <h2>{{ _notificacao.titulo }}</h2>
      <p>{{ _notificacao.descricao.texto }}</p>
    </div>

    <button class="modal-notificacao__close" (click)="dialogRef.close()">
      <ng-icon name="close"></ng-icon>
    </button>
  </div>

  @if (_notificacao.descricao?.link) {
    <div class="modal-notificacao-actions d-flex justify-content-end">
      <button class="my-btn my-btn--link" (click)="handleOpenLink()">
        Acessar link
        <ng-icon name="heroArrowUpRight" strokeWidth="1.8" size="16"></ng-icon>
      </button>
    </div>
  }
</div>
